const state = {
  isCreate: false,
  isBetSlip: false,
  isMatchDetail: false,
  isMatchRetry: false,
  sportsMatchList: [],
  userMatchList: [],
  detailItem: {},
  userOutcome : '',
  selectMatch : {},
  retryId: '',
}

const mutations = {
  SET_SPORTS_MATCH_LIST(state, payload) {
    state.sportsMatchList = payload
  },
  SET_USER_MATCH_LIST(state, payload) {
    state.userMatchList = payload
  },
  IS_CREATE(state, payload) {
    state.isCreate = payload
  },
  IS_BET_SLIP(state, payload) {
    state.isBetSlip = !state.isBetSlip
    if (payload) {
      state.userOutcome = payload
      const index = _.findIndex(state.sportsMatchList, {'matchid': payload.matchid});
      state.selectMatch =  state.sportsMatchList[index]
    }
  },
  IS_DETAIL(state, payload) {
    state.isMatchDetail = payload
  },

  ADD_DETAIL(state, payload) {
    state.detailItem = payload
  },
  ADD_MATCH_LIST(state, payload) {
    state.sportsMatchList = payload
  },

  CLEAR_ALL_POPUP(state) {
    state.isCreate = false
    state.isBetSlip = false
    state.isMatchDetail = false
    state.isMatchRetry = false
    state.userOutcome = {}
  },
  OPEN_MARKET_LIST(state, payload) {
    let index = _.findIndex(state.sportsMatchList, {'matchid': payload.matchId});
    if (index > -1) {
      let item = state.sportsMatchList[index];
      item.isMarkets = !item.isMarkets;
      item.markets = payload.markets;
    }
  },
  OPEN_RETRY(state, gameId) {
    state.isMatchRetry = true
    state.retryId = gameId
  },
}

const actions = {
  userMatch({commit}, payload) {
    commit('SET_USER_MATCH_LIST', payload)
  },
  clearAllPopup({commit}) {
    $('._layer_background').hide();
    commit('CLEAR_ALL_POPUP', false)
  },
  openCreate({commit}) {
    $('._layer_background').show();
    commit('IS_CREATE', true)
  },
  closeCreate({commit}) {
    $('._layer_background').hide();
    commit('CLEAR_ALL_POPUP', false)
  },
  openBetSlip({commit}, payload) {
    $('._layer_background').show();
    commit('IS_BET_SLIP', payload)
  },
  closeBetSlip({commit}) {
    commit('IS_BET_SLIP')
  },
  openDetail({commit}, payload) {
    $('._layer_background').show();
    commit('IS_DETAIL', true);
    commit('ADD_DETAIL', payload)
  },
  closeDetail({commit}) {
    $('._layer_background').hide();
    commit('CLEAR_ALL_POPUP', false)
  },
  addMatchList({commit}, payload) {
    commit('ADD_MATCH_LIST', payload)
  },
  openMarketList({commit}, matchid) {
    commit('OPEN_MARKET_LIST', matchid)
  },
  openRetry({commit}, gameId) {
    commit('CLEAR_ALL_POPUP', false)

    $('._layer_background').show();
    commit('OPEN_RETRY', gameId)
  },
}

const getters = {
  userMatchList: (state) => state.userMatchList,
  isCreate: (state) => state.isCreate,
  isBetSlip: (state) => state.isBetSlip,
  isMatchDetail: (state) => state.isMatchDetail,
  isMatchRetry: (state) => state.isMatchRetry,
  detailItem: (state) => state.detailItem,
  sportsMatchList: (state) => state.sportsMatchList,
  selectMatch: (state) => state.selectMatch,
  userOutcome: (state) => state.userOutcome,
  retryId: (state) => state.retryId,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/betMatch.js